import { useState, useEffect } from "react";
import { Link, useLocation, Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { api } from "../../lib/api";
import { LayoutDashboard, BookOpen, MessageSquare, RotateCcw, Film, Ticket, MessageCircleQuestion, Package, HardDrive } from "lucide-react";

export default function AdminLayout() {
  const { user, loading } = useAuth();
  const loc = useLocation();
  const [qaCount, setQaCount] = useState(0);
  useEffect(() => {
    if (user?.role === "admin")
      api.get("/admin/questions/unanswered-count").then((r) => setQaCount(r.data.count)).catch(() => {});
  }, [user, loc.pathname]);
  if (loading || user === null) return <p className="p-10 text-[var(--forge-dim)]">Loading…</p>;
  if (!user || user.role !== "admin") return <Navigate to="/auth?next=/admin" replace />;
  const links = [
    ["/admin", "Dashboard", LayoutDashboard],
    ["/admin/courses", "Courses", BookOpen],
    ["/admin/media", "Media", Film],
    ["/admin/storage", "Storage", HardDrive],
    ["/admin/coupons", "Coupons", Ticket],
    ["/admin/bundles", "Bundles", Package],
    ["/admin/qa", "Q&A", MessageCircleQuestion],
    ["/admin/reviews", "Reviews", MessageSquare],
    ["/admin/refunds", "Refunds", RotateCcw],
  ];
  return (
    <div className="max-w-7xl mx-auto px-4 pt-24 pb-10 grid md:grid-cols-[200px_1fr] gap-8">
      <aside>
        <p className="font-display text-[var(--forge-gold)] text-xs tracking-[0.25em] mb-4">ADMIN PANEL</p>
        <nav className="space-y-1">
          {links.map(([to, label, Icon]) => (
            <Link key={to} to={to} data-testid={`admin-nav-${label.toLowerCase()}`}
              className={`flex items-center gap-2 px-3 py-2 rounded text-sm transition-colors ${loc.pathname === to ? "bg-[rgba(56,189,248,0.1)] text-[var(--forge-blue)]" : "text-[var(--forge-dim)] hover:text-[var(--forge-text)]"}`}>
              <Icon size={15} />{label}
              {label === "Q&A" && qaCount > 0 && (
                <span data-testid="qa-unanswered-badge" className="ml-auto text-[10px] font-bold px-1.5 py-0.5 rounded-full"
                  style={{ background: "var(--gold)", color: "#14100a" }}>{qaCount}</span>
              )}
            </Link>
          ))}
        </nav>
      </aside>
      <div><Outlet /></div>
    </div>
  );
}
